import React from 'react'

import MicrocmsImage from '@atoms/MicrocmsImage'
import Image from '@models/Image'
import { CenterImageContent, isValidString } from '@models/Article'

import * as style from './style.module.sass'

type CenterImageProps = CenterImageContent & {
  isArtisan?: boolean
}

const CenterImage: React.FC<CenterImageProps> = ({
  image,
  width,
  url,
  contents,
  isArtisan,
}) => (
  <div className={style.wrapper}>
    <figure className={style.centerImage} data-width={width[0]}>
      {isValidString(url) ? (
        <a href={url} target="_blank" rel="noreferrer">
          <Contents image={image} contents={contents} isArtisan={isArtisan} />
        </a>
      ) : (
        <Contents image={image} contents={contents} isArtisan={isArtisan} />
      )}
    </figure>
  </div>
)

type ContentsProps = {
  image: Image
  contents: string | undefined | null
  isArtisan?: boolean
}
const Contents: React.FC<ContentsProps> = ({ image, contents, isArtisan }) => (
  <>
    <MicrocmsImage
      image={image}
      alt={isValidString(contents) ? contents : ''}
      type="largeHero"
    />
    {isValidString(contents) && (
      <figcaption
        className={style.caption}
        data-artisan={isArtisan}
        dangerouslySetInnerHTML={{ __html: contents }}
      />
    )}
  </>
)

export default CenterImage
